import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface BottomBarProps {
  children: ReactNode;
  className?: string;
}

export function BottomBar({ children, className }: BottomBarProps) {
  return (
    <div
      id="mobile-bottom-nav"
      className={cn(
        "h-[72px] min-w-0 shrink-0 rounded-t-2xl border-t border-slate-200 bg-white shadow-[0_-4px_16px_rgba(15,23,42,0.04)]",
        className,
      )}
    >
      <nav
        aria-label="Main navigation"
        className="flex h-full min-w-0 items-stretch gap-1 px-2 py-2"
      >
        {children}
      </nav>
    </div>
  );
}
